export const generateFooterStyles = ({ colors = {}, dimensions = {}, fontSpacing = {
    letterSpacing: { value: 0, unit: 'px' },
    lineHeight: { value: 1.5, unit: 'em' },
    wordSpacing: { value: 0, unit: 'px' }
} }) => `
.radio-player.footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    margin: 0;
    border-radius: 0;
    z-index: 9999;
    padding: 15px 20px;
    overflow: visible;
}

.radio-player.footer .player-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 10px;
    position: relative;
    overflow: visible;
}

.radio-player.footer .player-left {
    display: flex;
    align-items: center;
    gap: 15px;
    position: relative;
    overflow: visible;
}

.radio-player.footer .controls {
    display: flex;
    align-items: center;
    gap: 15px;
    padding: 0;
    position: relative;
    overflow: visible;
}

.radio-player.footer .player-center {
    display: flex;
    align-items: center;
    gap: 15px;
    flex: 1;
    min-width: 0;
}

.radio-player.footer .album-artwork {
    width: 63px;
    height: 63px;
    flex-shrink: 0;
    border-radius: 4px;
    overflow: hidden;
}

.radio-player.footer .player-info {
    flex: 1;
    min-width: 0;
}

.radio-player.footer .song-info {
    padding: 0;
}

.radio-player.footer .song-name {
    font-size: 16px;
    margin-bottom: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${colors?.text || 'white'} !important;
    letter-spacing: ${fontSpacing?.letterSpacing.value}${fontSpacing?.letterSpacing.unit};
    line-height: ${fontSpacing?.lineHeight.value}${fontSpacing?.lineHeight.unit};
    word-spacing: ${fontSpacing?.wordSpacing.value}${fontSpacing?.wordSpacing.unit};
}

.radio-player.footer .artist-name {
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    opacity: 0.8;
    color: ${colors?.text || 'white'} !important;
    letter-spacing: ${fontSpacing?.letterSpacing.value}${fontSpacing?.letterSpacing.unit};
    line-height: ${fontSpacing?.lineHeight.value}${fontSpacing?.lineHeight.unit};
    word-spacing: ${fontSpacing?.wordSpacing.value}${fontSpacing?.wordSpacing.unit};
}

.radio-player.footer .player-right {
    display: flex;
    align-items: center;
    gap: 15px;
}

.radio-player.footer .time-info {
    display: flex;
    align-items: center;
    max-width: fit-content;
    font-size: 14px;
    justify-content: left;
    color: ${colors?.text || 'white'} !important;
}

.radio-player.footer .radio-name {
    font-size: 14px;
    max-width: fit-content;
    color: ${colors?.text || 'white'} !important;
    letter-spacing: ${fontSpacing?.letterSpacing.value}${fontSpacing?.letterSpacing.unit};
    line-height: ${fontSpacing?.lineHeight.value}${fontSpacing?.lineHeight.unit};
    word-spacing: ${fontSpacing?.wordSpacing.value}${fontSpacing?.wordSpacing.unit};
}

.radio-player.footer .live-container {
    display: flex;
    align-items: center;
    gap: 5px;
    max-width: fit-content;
    padding: 4px 8px;
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.3);
}

.radio-player.footer .live-text {
    font-size: 14px;
    color: ${colors?.text || 'white'} !important;
    letter-spacing: ${fontSpacing?.letterSpacing.value}${fontSpacing?.letterSpacing.unit};
    line-height: ${fontSpacing?.lineHeight.value}${fontSpacing?.lineHeight.unit};
    word-spacing: ${fontSpacing?.wordSpacing.value}${fontSpacing?.wordSpacing.unit};
}

.radio-player.footer .time-bar-container {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 4px;
}

.radio-player.footer .time-bar {
    width: 100%;
    height: 100%;
    background: ${colors.timeBar ? `${colors.timeBar}33` : 'transparent'};
}

.radio-player.footer .time-bar-progress {
    height: 100%;
    background: ${colors.timeBar || '#333333'};
}

.radio-player.footer .volume-bar-container {
    position: absolute;
    bottom: calc(100% + 5px);
    left: 50%;
    transform: translateX(-40%);
    background: ${colors?.background || 'rgba(0, 0, 0, 0.9)'};
    padding: 12px 8px;
    border-radius: ${dimensions?.borderRadius || '12px'};
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s ease;
    z-index: 10000;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    cursor: default;
    height: 100px;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.radio-player.footer .volume-bar-container:before {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid ${colors?.background || 'rgba(0, 0, 0, 0.9)'};
}

.radio-player.footer .volume-bar-container.show {
    opacity: 1;
    visibility: visible;
}

.radio-player.footer .volume-slider {
    -webkit-appearance: none;
    width: 80px;
    height: 4px;
    background: ${colors?.timeBar ? `${colors.timeBar}40` : 'rgba(255, 255, 255, 0.2)'};
    border-radius: 2px;
    outline: none;
    transform: rotate(-90deg);
    transform-origin: center;
    margin: 0;
    cursor: pointer;
    position: absolute;
}

.radio-player.footer .volume-button {
    position: relative;
    overflow: visible;
}

.radio-player.footer .control-button {
    padding: 5px;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
}

.radio-player.footer .control-button.play-button {
    width: calc(36px * 1.3);
    height: calc(36px * 1.3);
    font-size: 1.5rem;
}

.radio-player.footer .control-button .fa-play {
    margin-left: 2px;
    font-size: inherit;
}

.radio-player.footer .control-button .fa-pause {
    font-size: inherit;
}
`; 